import React, { useContext } from 'react';
import {
  Dims,
  MeasuredCookieType,
} from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { default as Grid, Props as GridProps } from './Grid';

export interface Props extends GridProps {
  cookieType?: MeasuredCookieType;
  defaultSize?: {
    desktop: Dims;
    mobile: Dims;
  };
  containerClassName?: string;
}

const MeasuredGrid: React.FC<Props> = ({
  cookieType,
  defaultSize,
  containerClassName,
  ...gridProps
}) => {
  const { width: screenWidth } = useContext(ScreenSizeContext);
  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    cookieType,
    {
      cookieDim: 'width',
      defaultSize,
    }
  );

  return (
    <>
      <div className={containerClassName} ref={ref}>
        <Grid
          {...gridProps}
          screenWidth={screenWidth}
          containerWidth={measuredContainer?.width}
        />
      </div>
    </>
  );
};
MeasuredGrid.displayName = 'MeasuredGrid';
export default MeasuredGrid;
